import { Box, TextField, Typography } from '@mui/material';
import { Component, createRef } from 'react';
import AppManager from '../../commun/AppManager';
import { Spinner } from '../../commun/component/Spinner';
import { post } from '../../commun/HTTP';
import { PerfectAJOList } from '../../commun/object/PerfectAJOList';
import Result from '../../commun/Result';
import Toast from '../../commun/toast/Toast';
import BasePrice from '../../object/BasePrice';
import Prestation from '../../object/profile/Prestation';
import { JSXInternal } from 'preact/src/jsx';
import Category from '../../object/tag/Category';
import { getErrorMessage } from '../../utils/Error';
import { SelectCategoryList } from '../category/SelectCategoryList';
import MpModal, { IBaseModalProps } from '../extends/MpModal';
import { Honoraire } from 'src/object/Honoraire';
import { CategoryHonoraire } from 'src/object/CategoryHonoraire';

export interface IHonoraireModalProps extends IBaseModalProps {
    honoraire: Honoraire | null;
    baseName?: string;
    baseCategory?: CategoryHonoraire;
    onCreate?: (prestation: Honoraire) => void;
}

export interface IHonoraireModalState {
    name: string;
    category: CategoryHonoraire | null;
    loading: boolean;
    error: string;
}

export default class HonoraireModal extends Component<IHonoraireModalProps, IHonoraireModalState> {
    inputRef: React.RefObject<HTMLInputElement>;
    categoryHonoraireList: PerfectAJOList<CategoryHonoraire>;

    constructor(props: IHonoraireModalProps) {
        super(props);

        this.state = this.initState();
        this.inputRef = createRef();

        this.categoryHonoraireList = new PerfectAJOList('/categoryhonoraire/list', () => {
            return {};
        });
    }

    initState() {
        const p: IHonoraireModalState = {
            name: this.props.honoraire?.name.get() ?? this.props.baseName ?? '',
            category: this.props.baseCategory ?? null,
            loading: false,
            error: '',
        };
        return p;
    }

    componentDidUpdate(
        prevProps: Readonly<IHonoraireModalProps>,
        prevState: Readonly<IHonoraireModalState>,
        snapshot?: any,
    ): void {
        if (prevProps.open !== this.props.open) {
            this.setState(this.initState());
        }
        if (prevProps.open !== this.props.open && this.props.open) {
            setTimeout(() => {
                this.inputRef.current?.focus();
            });
        }
    }

    addPrestation() {
        const { loading, name } = this.state;
        const { honoraire } = this.props;
        this.setState({
            loading: true,
            error: '',
        });
        let params: any;
        let url: string;
        if (honoraire === null) {
            url = '/honoraire/update';
            params = {
                name: name,
                category_honoraire: {
                    id: this.state.category?.getAjoIdentifier(),
                },
            };
        } else {
            url = '/honoraire/update';
            params = {
                id: honoraire.getAjoIdentifier(),
                name: name,
                category_honoraire: {
                    id: this.state.category?.getAjoIdentifier(),
                },
            };
        }
        if (honoraire !== null) {
            params['id'] = honoraire.getAjoIdentifier();
        }
        post(url, params).then((res: any) => {
            this.setState({
                loading: false,
            });
            if (Result.isSuccess(res)) {
                Result.applyResult(res, AppManager.updater(), true);

                const p = Prestation.build();
                Result.applyResult(res, p, true);

                this.props.onClose();
                if (honoraire === null) {
                    AppManager.addToast(new Toast("L'honoraire a été ajouté avec succès.", 'success'));
                } else {
                    AppManager.addToast(new Toast("L'honoraire a été modifié avec succès.", 'success'));
                }
                this.props.onCreate?.(p);
            } else {
                this.setState({
                    error: getErrorMessage(Result.getErrorStr(res)),
                });
            }
        });
    }

    render(): JSXInternal.Element {
        const { open, honoraire, onClose } = this.props;
        const { loading, name, error } = this.state;

        if (open) {
            this.categoryHonoraireList.need();
        }

        return (
            <MpModal
                open={open}
                onClose={onClose}
                onSubmit={() => {
                    this.addPrestation();
                }}
                title={honoraire === null ? 'Ajouter un honoraire' : 'Modifier un honoraire'}
                done={honoraire === null ? 'Ajouter' : 'Modifier'}
            >
                {loading ? (
                    <Box className="flex items-center justify-center py-12">
                        <Spinner color="blue" className="" />
                    </Box>
                ) : (
                    <Box className="flex flex-col !text-gray-600 gap-2">
                        <Typography className="!text-sm !font-semibold">NOM DE L'HONORAIRE</Typography>
                        <TextField
                            inputProps={{
                                ref: this.inputRef,
                            }}
                            fullWidth
                            value={name}
                            onChange={(e) => {
                                this.setState({ name: (e.target as any).value });
                            }}
                            placeholder="Nom de l'honoraire"
                            variant="outlined"
                        />

                        <Typography className="!text-sm !font-semibold">CATÉGORIE DE L'HONORAIRE</Typography>
                        <SelectCategoryList
                            list={this.categoryHonoraireList.getList()}
                            single={true}
                            selectList={this.state.category === null ? [] : [this.state.category]}
                            onSelectList={(list) => {
                                if (list.length > 0) {
                                    this.setState({
                                        category: list[0],
                                    });
                                } else {
                                    this.setState({
                                        category: null,
                                    });
                                }
                            }}
                        />

                        {error !== '' && (
                            <Typography
                                component={'p'}
                                className="!text-sm text-red-600 !mt-1 !mb-1 !font-medium text-center"
                            >
                                {error}
                            </Typography>
                        )}
                    </Box>
                )}
            </MpModal>
        );
    }
}
